export type TWalletNetwork = 'mainnet' | 'testnet'

export const WALLET_NETWORKS: TWalletNetwork[] = ['mainnet', 'testnet']
